import { dataFileStar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileStar = /*#__PURE__*/createIcon(dataFileStar)
export default IconFileStar
